import React__default from 'react';
import { useController } from 'react-hook-form';
import { RadioGroup } from '../../../atoms/RadioGroup.js';
import { FormItem } from '../FormItem.js';
import { ReadOnlyField, formatReadOnlyValue } from './ReadOnlyFormField.js';

/**
 * RadioGroupFormField - A form field component for radio group input.
 *
 * @example
 * ```tsx
 * <Form schema={schema} onSubmit={handleSubmit}>
 *   <RadioGroupFormField
 *     schemaField="paymentMethod"
 *     labelText="Payment Method"
 *     items={[
 *       { value: 'credit', label: 'Credit Card' },
 *       { value: 'debit', label: 'Debit Card' },
 *     ]}
 *   />
 * </Form>
 * ```
 */
function RadioGroupFormField({ schemaField, labelText, descriptionText, isReadOnly, isDisabled, required, className, id, items, linkedField, showFieldToggle, ...radioGroupProps }) {
    const { field } = useController({
        name: schemaField,
        shouldUnregister: false,
    });
    if (isReadOnly) {
        return (React__default.createElement(ReadOnlyField, { label: labelText, value: formatReadOnlyValue(field.value, 'radio', { radioOptions: items }), description: descriptionText, required: required, className: className }));
    }
    return (React__default.createElement(FormItem, { schemaField: schemaField, labelText: labelText, descriptionText: descriptionText, required: required, className: className, id: id, isDisabled: isDisabled, linkedField: linkedField, showFieldToggle: showFieldToggle },
        React__default.createElement(RadioGroup, { ...radioGroupProps, items: items, isDisabled: isDisabled, isReadOnly: isReadOnly })));
}

export { RadioGroupFormField };
//# sourceMappingURL=RadioGroupFormField.js.map
